// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__J1EI_","buttons":"RemoveExpirationActionButtons_buttons__1CfOA"};